import { TESTDATA_MODAL } from '@enums/overlay-internal-events.enum';
import { TEST_DATA_SYMBOLS } from '@enums/test-data-symbols.enum';
import MailBoxService from '@services/mail-box.service';
import {
  useInternalEvents,
  useTranslation,
  useAnimatedClass,
} from '@testsigma/atoms';
import { EmailBoxValueSelector } from '@testsigma/organism';
import { useCallback, useState } from 'react';

import {
  TestDataDrawerHelpInfoProps,
  TestDataDrawerLayout,
} from './test-data-drawer-layout';
import classNames from 'classnames';
import { useInfiniteQuery } from 'react-query';
import { useReactQueryCaching } from '@hooks/use-react-query-caching';
import { CachingPrefix } from '@enums/caching-prefix.enum';

export const MailBoxDrawer = ({ isInsideRestApi = false }) => {
  const { t } = useTranslation();
  const publishInternalEvents = useInternalEvents([]);
  const { getCachingTime } = useReactQueryCaching(
    CachingPrefix.FETCH_TESTDATA_MAILBOX,
    false,
  );
  const [searchTerm, setSearchTerm] = useState('');
  const onClose = useCallback(
    () =>
      publishInternalEvents(
        TESTDATA_MODAL.CLOSE_MAILBOX,
        isInsideRestApi ? { isInsideRestApi: true } : null,
      ),
    [publishInternalEvents],
  );

  const { data, fetchNextPage, hasNextPage, isFetching } = useInfiniteQuery(
    [`${CachingPrefix.FETCH_TESTDATA_MAILBOX}-${searchTerm || ''}`],
    async ({ pageParam = 0 }) => {
      const query = `${searchTerm ? `email:*${searchTerm}*` : ''}`;
      const checkData = await MailBoxService.findAll(query, 20, pageParam);
      return checkData;
    },

    {
      getNextPageParam: (lastPage) =>
        lastPage?.last ? undefined : lastPage?.pageable?.pageNumber + 1,
      staleTime: getCachingTime(),
      cacheTime: getCachingTime(),
    },
  );

  const modifiedData = data?.pages?.flatMap((item) => item?.content) || [];
  const onDataClick = useCallback(
    (item) => {
      publishInternalEvents(TESTDATA_MODAL.SELECTED_MAILBOX, item);
    },
    [publishInternalEvents],
  );

  const helpInfoProps: TestDataDrawerHelpInfoProps = {
    description: t('modal.help.mail_box'),
    url: 'https://testsigma.com/docs/test-data/types/mailbox/',
  };

  const animationClass = useAnimatedClass('reval-animation-opacity');

  return (
    <TestDataDrawerLayout
      title={t('modal.title.mailbox')}
      symbol={TEST_DATA_SYMBOLS.EMAIL}
      onClose={onClose}
      helpInfo={helpInfoProps}
    >
      <div className={classNames('px-5  py-6 h-full', animationClass)}>
        <EmailBoxValueSelector
          mailboxes={modifiedData || []}
          onClick={onDataClick}
          isFetching={isFetching}
          onChangeSearch={setSearchTerm}
          hasMore={hasNextPage}
          handleLoadMore={fetchNextPage}
          searchTerm={searchTerm}
        />
      </div>
    </TestDataDrawerLayout>
  );
};
